<template>
    <div >
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'订单管理'},{title:'海乐苗toC订单'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="OMS订单编码">
                            <el-input clearable v-model="q.sapCode"></el-input>
                        </el-form-item>
                        <el-form-item label="预约平台订单编码">
                            <el-input clearable v-model="q.orderNo"></el-input>
                        </el-form-item>
                        <el-form-item label="预约平台发票号">
                            <el-input clearable v-model="q.billNo"></el-input>
                        </el-form-item>
                        <el-form-item label="不开票标签">
                            <brselect category="shifou_keyong" :v="q.noBillTag" v-model="q.noBillTag"></brselect>
                        </el-form-item>

                    </div>

                </el-form>
                <div class="l-screenBox">

                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>

                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border

                        style="width: 100%"

                >
                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="#"
                            fixed >
                    </el-table-column>
                    <el-table-column
                            prop="sapCode"
                            label="OMS订单号"
                            width="180"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="sapBill"
                            label="sap发票号码"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="orderNo"
                            label="预约平台订单编码"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="billNo"
                            label="预约平台的发票号码"
                            width="280">
                    </el-table-column>
                    <el-table-column
                            prop="invoiceAmount"
                            label="预约平台开票金额"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>

                    <el-table-column
                            prop="noBillTag"
                            label="不开票标签"
                            width="110">
                        <template scope="scope">
                            {{scope.row.noBillTag|dictname('shifou_keyong')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建日期"
                            width="160"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新日期"
                            width="160"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="120" >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="setNobilltag(scope.row)">设置不开票</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
                    <div style="display:flex;align-items: center;">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ"
                                   @click="nobilltagBatch" >批量设置不开票
                        </el-button>


                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from "../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
                //查询属性
                q: {
                    sapCode:null,
                    orderNo:null,
                    noBillTag:null,
                    billNo:null,
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                tableSelectedList:[],
                //table列表
                tableData: [],

            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {

                ss.OrderMainService.selectHlmToCPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    sapCode:null,
                    orderNo:null,
                    noBillTag:null,
                    billNo:null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },

            //批量导出
            exportExcel() {
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                var form = {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    sapCode:null,
                    orderNo:null,
                    noBillTag:null,
                    billNo:null
                };
                if (strids == '') {
                    form = _.clone(this.q);
                }
                form.strids = strids;
                updownfile.down("/api/swyl/v1/dingdhlmtoc/downloadExcel", form, "post");
            },
            setNobilltag(obj){
                this.$msg.confirm("确认将"+obj.orderNo+"订单设置为不开票?", () => {
                    ss.OrderMainService.setNobilltag(obj.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });

            },
            nobilltagBatch(){
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                this.$msg.confirm("确认订单不开票?", () => {
                    ss.OrderMainService.nobilltagBatch(strids).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });

            }
        }
    }
</script>
